<template>
  <div class="wrap" v-loading="allLoading">
    <div class="main-wrap my-orders">
      <!-- 导航 -->
      <div class="order-navigation">
        <a
          class="text1"
          href="/#/catalogue"
        >{{L.home}}</a>
        <span class="line">/</span>
        <a
          class="text2"
          href="/#/shipment" 
        >{{L.myShipment}}</a>
      </div>
      <!-- 我的订单-标题 -->
      <div class="my-orders-title">{{L.myShipment}}</div>
      <!-- 搜索 -->
      <div class="search-wrap">
        <el-form :model="search" ref="formSearch" :show-message="false">
          <div class="square">
            <span class="text">{{L.orderID}}:</span>
            <el-form-item prop="contractCode">
              <el-input size="mini" @keyup.enter.native="getList(2)" v-model="search.contractCode" class="search-field"></el-input>
            </el-form-item>
          </div>
          <div class="square">
            <span class="text">{{L.productNo}}:</span>
            <el-form-item prop="module">
              <el-input size="mini" @keyup.enter.native="getList(2)" v-model="search.module" class="search-field"></el-input>
            </el-form-item>
          </div>
          <div class="square">
            <span class="text">{{L.finishedOrNot}}:</span>
            <el-form-item prop="ifFinish">
              <el-select size="mini" v-model="search.ifFinish" class="search-field" placeholder="" clearable>
                <el-option
                  v-for="item in statusArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <!-- 按钮 -->
      <div class="btn-wrap">
        <div class="left">
          <div class="fill" @click="handleDownload">{{L.shipmentList}}</div>
        </div>
        <div class="right">
          <div class="null" @click="clearFilters">{{L.cleaFilters}}</div>
          <div class="fill" @click="getList(2)">{{L.search}}</div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="table-wrap">
        <el-table
          :header-cell-style="getHeaderCellStyle"
          highlight-current-row
          size="small"
          :data="list"
          border
          style="width: 100%"
        >
          <el-table-column
            fixed="left"
            width="180"
            prop="contractCode"
            :label="tableLable.orderID">
            <template slot-scope="scope">
              <a class="order-no" :href="shipDetailUrl(scope.row.bodyId)">{{scope.row.contractCode}}</a>
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            prop="dealerName"
            :label="tableLable.dealerName">
          </el-table-column>
          <el-table-column
            prop="portNameRev"
            width="120"
            :label="tableLable.portName">
          </el-table-column>
          <el-table-column
            prop="salerName"
            :label="tableLable.salesman">
          </el-table-column>
          <el-table-column
            prop="module"
            width="180"
            :label="tableLable.productNo">
          </el-table-column>
          <el-table-column
            width="150"
            prop="qty"
            :label="tableLable.quantity">
          </el-table-column>
          <el-table-column
            prop="price"
             width="150"
            :label="tableLable.unitPrice">
            <template slot-scope="scope">
              <span>{{formatMoney(scope.row.price)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="amount"
            width="150"
            :label="tableLable.totalAmount">
            <template slot-scope="scope">
              <span>{{formatMoney(scope.row.amount)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="outQty"
            width="150"
            :label="tableLable.soldQuantity">
          </el-table-column>
          <el-table-column
            prop="outAmount"
            width="150"
            :label="tableLable.soldAmount">
            <template slot-scope="scope">
              <span>{{formatMoney(scope.row.outAmount)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="100"
            prop="shipDate"
            :label="tableLable.shippingDate">
          </el-table-column>
          <!-- 表格没数据的时候展示空组件，要注意这里的slot=empty不能随意更改 -->
          <div slot="empty">
            <NoContent/>
          </div>
        </el-table>
        <Pagination :pageObj="paginationObj" @sizeChange="sizeChange" @currentChange="currentChange"/>
      </div>
    </div>
    
    
  </div>
</template>

<script>
import {postAction,downFilePost} from '@/api/tool'
import {api_led_ship_list,api_led_export_list} from '@/api/api'
import NoContent from '@/components/NoContent'
import Pagination from '@/components/Pagination'

export default {
  name:'CreditNotesList',
  components:{
    NoContent,
    Pagination
  },
  data(){
    return {
      search:{
        contractCode:'',
        module:'',
        ifFinish:''
      },
      list:[], //列表数据
      tableLable:{
        orderID:'',
        dealerName:'',
        portName:'',
        salesman:'',
        productNo:'',
        quantity:'',
        unitPrice:'',
        totalAmount:'',
        soldQuantity:'',
        soldAmount:'',
        shippingDate:''
      } //表格的表头，因为这个地方切换语言的时候没办法正常渲染，所以需要监听语言包的变化，进行重新渲染
    }
  },
  computed:{
    statusArr(){
      return [
        {value:'Y',label:this.L.yes},
        {value:'N',label:this.L.no}
      ]
    }
  },
  watch:{
    L(newVal){
      this.tableLable=newVal
    }
  },
  methods:{
    /* 下载 */
    handleDownload(){
      this.allLoading=true
      downFilePost(api_led_export_list,this.search).then(res=>{
        this.allLoading=false
        this.downloadFile(res)
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 获取列表,如果是2的话，从第一页开始 */
    getList(flag=1){
      let params = {}
      if(flag==2){
        this.paginationObj.currentPage=1
      }
      params.pageNo=this.paginationObj.currentPage
      params.pageSize=this.paginationObj.pageSize
      params.params=this.search
      this.allLoading=true
      postAction(api_led_ship_list,params).then(res=>{
        this.allLoading=false
        this.paginationObj.total=Number(res.total)
        this.list=res.records
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 重置搜索条件并且直接请求数据 */
    clearFilters(){
      this.search={
        contractCode:'',
        module:'',
        ifFinish:''
      }
      this.getList(2)
    }
  },
  mounted(){
    this.tableLable=this.L
    this.getList(2)
  }
}
</script>

<style lang="less" scoped>
@import url('/public/css/public.less');
@import url('./index.less');
</style>

